import Image from "next/image";

const ChatEmptyState = ({
	title,
	description,
}: {
	title?: string;
	description?: React.ReactNode;
}) => {
	return (
		<div className="p-4 text-center">
			<Image
				src="/images/chat/start-new-conversation.svg"
				alt="Start new conversation"
				className="mx-auto w-40 lg:w-64"
				width={691}
				height={481}
			/>

			<h4 className="mt-8 text-2xl font-semibold text-gray-600 lg:text-3xl">
				{title || "Say Hello!👋"}
			</h4>
			<p className="mt-2 text-sm text-gray-400">{description || "Start a conversation"}</p>
		</div>
	);
};

export default ChatEmptyState;
